import Router from 'next/router';
import { useCallback } from 'react';

import { SIGN_TYPE, SIGN_TYPES } from '~/shared/components/Sign/types';
import { useSign } from '~/shared/hooks/useSign';
import { LoggingCategory } from '~/utils/constants';
import { logger } from '~/utils/loggerUtil';
import { sendDataLayerEvent } from '~/utils/measurementUtils';
import { addNotificationToLocalStorage } from '~/utils/storageUtils';

import { routes } from '../../../routes';

export const useSignTab = router => {
  const { signUp, signIn, isSubmitting, redirectToCallback } = useSign();

  const onClickTab = useCallback(
    (currentTab: SIGN_TYPE) => {
      Router.push({
        pathname:
          currentTab === SIGN_TYPES.SIGN_UP
            ? routes.signUp.path
            : routes.signIn.path,
        query: router.query,
      });
    },
    [router.query]
  );
  const onSubmitSignUp = useCallback(
    data => {
      signUp(data.email, data.password).then(() => {
        // 遷移後のページで通知を表示
        addNotificationToLocalStorage({
          title: '会員登録が完了しました',
          message: `${data.email} 宛にメールを送信しましたのでご確認ください。`,
        });
        sendDataLayerEvent(LoggingCategory.SUCCEED_SIGNING_UP);
        // ログイン後リダイレクト
        redirectToCallback();
      });
    },
    [redirectToCallback, signUp]
  );
  const onSubmitSignIn = useCallback(
    data => {
      signIn(data.email, data.password).then(() => {
        logger.debug('success signIn');
        sendDataLayerEvent(LoggingCategory.SUCCEED_SIGNING_IN);
        // ログイン後リダイレクト
        redirectToCallback();
      });
    },
    [redirectToCallback, signIn]
  );

  return {
    onClickTab,
    onSubmitSignIn,
    onSubmitSignUp,
    isSubmitting,
  };
};
